import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import Icon from 'assets/icons';
import { VerticalListItem, Loader, GetVerticalNavigationQuery } from 'components';

import styles from './TickerNav.module.scss';
import { groupIntegrations } from 'helpers/integrations';

interface TickerNavData {
  me: {
    integrations: UserIntegration[];
  };
}

const NavLoadingState = () => {
  return (
    <div className={styles.container}>
      <div className={styles.bin}>
        <Loader />
      </div>
    </div>
  );
};

export const TickerNav = () => {
  const { error, data } = useQuery<TickerNavData>(GetVerticalNavigationQuery, {
    fetchPolicy: 'cache-first',
  });

  const userIntegrations = data?.me.integrations || [];
  const groupedIntegrations = React.useMemo(() => groupIntegrations(userIntegrations), [
    userIntegrations,
  ]);

  if (data === undefined) return <NavLoadingState />;

  if (error) return <NavLoadingState />;

  return (
    <div className={styles.container}>
      <div className={styles.bin}>
        {/* Link to Activity Feed */}
        <VerticalListItem
          type="activity-feed"
          name="Activity Feed"
          navigationType="Simple"
          icon={<Icon.ActivityFeed className={styles.icon} textPosition="Left" />}
        />

        {/* List of Integrations */}
        {groupedIntegrations.map((integrations: UserIntegration[], key) => (
          <VerticalListItem
            key={key}
            type="integration"
            navigationType="Simple"
            name={integrations[0].title}
            integrations={integrations}
            icon={<div />}
          />
        ))}
      </div>
    </div>
  );
};
